export function getBearerToken(): Promise<any> {
    let loginFormValues: URLSearchParams = new URLSearchParams();
    loginFormValues.append("grant_type", "password");
    loginFormValues.append("username", (<HTMLInputElement>document.getElementById("username")).value);
    loginFormValues.append("password", (<HTMLInputElement>document.getElementById("password")).value);

    const selectedApi = (<HTMLSelectElement>(document.getElementById("api"))).value;
    const tokenEndpointUrl = `${selectedApi}/token`;

    return fetch(tokenEndpointUrl, {
        method: "post",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "site": `${(<HTMLInputElement>document.getElementById("siteCode")).value}`
        },
        body: loginFormValues
    })
    .then(response => response.json())
    .then(responseAsJson => { return responseAsJson })
    .catch(error => console.error(error));
}

export function getSegments(token: string): Promise<any> {
    const selectedApi = (<HTMLSelectElement>(document.getElementById("api"))).value;
    const segmentEndpointUrl = `${selectedApi}/api/segments`;

    return fetch(segmentEndpointUrl, {
        method: "get",
        headers: {
            "Authorization": `Bearer ${token}`,
            "moduleid": "1"
        }
    })
    .then(response => response.json())
    .then(responseAsJson => { return responseAsJson })
    .catch(error => console.error(error))
}